<template>
  <div class="min-h-screen">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'authentication',
};
</script>

<style scoped>

</style>
